import _typeof from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ossRequest } from '@/util/axios-request';

/**
 * Excel 导入上传组件
 *
 * @description
 * 基于 el-upload 二次封装的 Excel 导入组件，将完整链路拆为两步：
 *
 * **第 1 步：模板下载**（与导入完全独立）
 * `templateProps` 支持两种形态：
 * - `String`：视为 OSS 链接，等价 `{ url: string }`
 * - `Object`：`TemplateConfig`
 *   - 默认用 `url` 走 `window.open`
 *   - 提供 `download` 时完全接管下载（鉴权、POST、Blob 等），`url` 可省略
 *   - `title` / `description` / `buttonText` 有默认值
 *   - `titleShow` / `descriptionShow` 控制标题 / 描述显隐
 *
 * **第 2 步：导入**
 * 1. 获取 OSS 凭证（`uploadProps`）
 * 2. PUT 文件到 OSS（进度通过 `options.onProgress` 同步到 el-upload 文件列表）
 * 3. 触发业务导入（`importProps`）
 * 4. 获取结果：
 *    - `mode='sync'`：导入接口直接返回结果，经 `importProps.adapter` 解析
 *    - `mode='async'`：轮询 `statusProps.url`，`found=true` 后经 `statusProps.adapter` 解析结果
 */
export default {
  name: 'ExcelUpload',
  props: {
    /**
     * 导入结果获取方式
     * - `sync`：导入接口直接返回结果
     * - `async`：触发导入后轮询状态接口获取结果
     * @type {'sync'|'async'}
     * @default 'sync'
     */
    mode: {
      type: String,
      default: 'sync',
      validator: function validator(v) {
        return ['sync', 'async'].includes(v);
      }
    },
    /**
     * 文件列表，支持 `v-model`
     * @type {Array<Object>}
     * @default []
     */
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * 文件大小上限（单位：MB）
     * @type {number}
     * @default 5
     */
    maxSize: {
      type: Number,
      default: 5
    },
    /**
     * 允许上传的文件数量上限
     * @type {number}
     * @default 1
     */
    limit: {
      type: Number,
      default: 1
    },
    /**
     * 原生 `accept`，仅用于文件选择器预过滤
     * @type {string}
     * @default '.xlsx,.xls'
     */
    accept: {
      type: String,
      default: '.xlsx,.xls'
    },
    /**
     * 允许的扩展名列表（不含点），用于 `validateFile` 校验
     * @type {Array<string>}
     * @default ['xlsx', 'xls']
     */
    acceptExt: {
      type: Array,
      default: function _default() {
        return ['xlsx', 'xls'];
      }
    },
    /**
     * 允许的 MIME 类型列表，用于 `validateFile` 校验（为空数组时跳过 MIME 校验）
     * @type {Array<string>}
     * @default ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
     */
    acceptMime: {
      type: Array,
      default: function _default() {
        return ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
      }
    },
    /**
     * 选择文件后是否自动开始上传流程
     * - `true`：选完即上传
     * - `false`：选完进入待上传队列，需调用 `ref.submit()` 手动触发
     * @type {boolean}
     * @default true
     */
    autoStart: {
      type: Boolean,
      default: true
    },
    /**
     * 是否禁用整个上传交互
     * @type {boolean}
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示 el-upload 的文件列表
     * @type {boolean}
     * @default true
     */
    showFileList: {
      type: Boolean,
      default: true
    },
    /**
     * 是否显示导入结果区域
     *
     * 仅控制默认结果 UI，不影响 `resultData`、`success` 事件及 el-upload 成功状态。
     * @type {boolean}
     * @default true
     */
    showResult: {
      type: Boolean,
      default: true
    },
    /**
     * 是否显示异步轮询提示（仅影响默认 UI，`pollingTip` 状态与 `polling` 事件不受影响）
     * @type {boolean}
     * @default true
     */
    showPollingTip: {
      type: Boolean,
      default: true
    },
    /**
     * 上传前钩子，返回 `false` 或 `Promise.reject` 可中断上传
     * @type {Function|null}
     * @default null
     */
    beforeUpload: {
      type: Function,
      default: null
    },
    /**
     * 完全接管上传逻辑；传入后将跳过组件默认的两步上传 + 导入流程
     * 签名同 el-upload 的 `http-request`：
     * `(options) => void | Promise | RequestHandle`
     * @type {Function|null}
     * @default null
     */
    customRequest: {
      type: Function,
      default: null
    },
    /**
     * 第 1 步：模板下载配置
     * - `String`：视为 OSS 链接（语法糖，等价 `{ url }`）
     * - `Object`：`TemplateConfig`
     *
     * Object 形态字段：
     * - `url`：下载地址，未提供 `download` 时必填
     * - `visible`：是否显示区域，默认 `true`
     * - `title`：标题，默认 `'1. 下载导入模板'`
     * - `titleShow`：是否显示标题，默认 `true`
     * - `description`：描述，默认 `'请先下载模板，按格式填写后再上传'`
     * - `descriptionShow`：是否显示描述，默认 `true`
     * - `buttonText`：按钮文案，默认 `'模板下载'`
     * - `download`：`({ open }) => void | Promise<void>`，提供则完全接管下载
     *
     * @type {string|TemplateConfig}
     * @default { visible: true, url: '' }
     */
    templateProps: {
      type: [String, Object],
      default: function _default() {
        return {
          visible: true,
          url: ''
        };
      }
    },
    /**
     * 第 2 步-1：获取 OSS 凭证（**必传**）
     *
     * Object 形态：`{ url, method?, params?, adapter? }`
     * Function 形态：`({ file }) => Credential | Promise<Credential>`
     * Function 将完全接管凭证获取，并直接返回标准 Credential。
     *
     * `adapter(raw, { type: 'credential', file })` 需返回：
     * `{ putUrl, objectUrl, objectKey, contentType, method? }`
     * @type {Object|Function}
     * @required
     */
    uploadProps: {
      type: [Object, Function],
      required: true
    },
    /**
     * 第 2 步-3：触发业务导入（**必传**）
     *
     * Object 形态：`{ url, method?, params?, adapter? }`
     * Function 形态：`({ file, credential }) => any | Promise<any>`
     * Function 将完全接管业务导入请求，其返回值将作为导入响应。
     *
     * `adapter(raw, { type: 'result', file, credential })` 需返回（同步模式）：
     * `{ successCount, failCount, failFileUrl? }`
     * @type {Object|Function}
     * @required
     */
    importProps: {
      type: [Object, Function],
      required: true
    },
    /**
     * 第 2 步-4：异步轮询配置（`mode='async'` 时**必传**）
     *
     * Object 形态：`{ url, method?, params?, interval?, maxCount?, adapter? }`
     * Function 形态：`({ file, credential, importResponse }) => ApiConfig | Promise<ApiConfig>`
     *
     * `adapter(raw, { type: 'status', file, credential, importResponse })` 需返回：
     * `{ found, successCount?, failCount?, failFileUrl? }`
     * @type {Object|Function|null}
     * @default null
     */
    statusProps: {
      type: [Object, Function],
      default: null
    }
  },
  data: function data() {
    return {
      /** @type {Array<Object>} el-upload 文件列表 */
      fileList: [],
      /** @type {boolean} 是否正在上传 / 导入中 */
      uploading: false,
      /** @type {boolean} 模板是否下载中（防重复点击） */
      templateLoading: false,
      /** @type {boolean} 轮询是否已停止（组件销毁时置 true） */
      pollingStopped: false,
      /** @type {string} 轮询提示文案 */
      pollingTip: '',
      /** @type {boolean} 是否显示导入结果区 */
      resultVisible: false,
      /** @type {ImportResult|StatusResult|Object} 导入结果数据 */
      resultData: {},
      /** @type {number|null} 轮询 setTimeout 句柄，用于销毁时清理 */
      _pollTimer: null
    };
  },
  computed: {
    /**
     * 模板下载区域元信息
     *
     * 统一解析 `templateProps` 两种形态，并集中处理默认值：
     *
     * 默认值：
     * - `title`：'1. 下载导入模板'
     * - `description`：'请先下载模板，按格式填写后再上传'
     * - `buttonText`：'模板下载'
     *
     * 显示控制：
     * - `titleShow`：`titleShow !== false && !!title`
     * - `descriptionShow`：`descriptionShow !== false && !!description`
     *
     * 形态规则：
     * - `String`：语法糖，等价 `{ url }`，默认值全部生效
     * - `Object`：字段直读，未传的字段走默认值
     *
     * 注意：`download` 只作为「是否显示」的判断依据，**不会在 computed 中执行**。
     */
    templateMeta: function templateMeta() {
      /** 默认文案，可按业务统一调整 */
      var DEFAULTS = {
        title: "1. ".concat(this.$t('47')),
        // 下载导入模板
        description: this.$t('i18n.d47430700982442fa686294f0a5bd7b0'),
        // 根据提示信息本地修改后再次上传
        buttonText: this.$t('778') // 模板下载
      };

      var p = this.templateProps;
      var cfg = typeof p === 'string' ? {
        url: p
      } : p || {};
      var title = cfg.title !== undefined ? cfg.title : DEFAULTS.title;
      var description = cfg.description !== undefined ? cfg.description : DEFAULTS.description;
      var buttonText = cfg.buttonText || DEFAULTS.buttonText;
      var hasUrl = !!cfg.url;
      var hasDownloadFn = typeof cfg.download === 'function';
      return {
        visible: cfg.visible !== false && (hasUrl || hasDownloadFn),
        title: title,
        titleShow: cfg.titleShow !== false && !!title,
        description: description,
        descriptionShow: cfg.descriptionShow !== false && !!description,
        buttonText: buttonText,
        hasDownloadFn: hasDownloadFn
      };
    }
  },
  watch: {
    /**
     * 同步外部 `v-model` 文件列表到内部 `fileList`
     */
    value: {
      immediate: true,
      handler: function handler(v) {
        if (Array.isArray(v) && v !== this.fileList) {
          this.fileList = v;
        }
      }
    }
  },
  /**
   * 组件销毁：停止轮询、清理定时器，避免内存泄漏与卸载后 setState
   */
  beforeDestroy: function beforeDestroy() {
    this.pollingStopped = true;
    if (this._pollTimer) {
      clearTimeout(this._pollTimer);
      this._pollTimer = null;
    }
  },
  methods: {
    /**
     * 触发模板下载（第 1 步）
     *
     * 根据 `templateProps` 分发：
     * - Object 且含 `download` 函数：`await download({ open })`，完全接管
     * - 否则使用 `url`：`window.open(url, '_blank', 'noopener,noreferrer')`
     *
     * 组件统一负责 loading / 异常提示 / 事件派发。
     *
     * @returns {Promise<void>}
     * @fires ExcelUpload#template-download-success
     * @fires ExcelUpload#template-download-error
     */
    downloadTemplate: function downloadTemplate() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var p, cfg, hasDownloadFn, err;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.templateLoading) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              p = _this.templateProps;
              cfg = typeof p === 'string' ? {
                url: p
              } : p || {};
              if (!(cfg.visible === false)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              hasDownloadFn = typeof cfg.download === 'function';
              if (!(!hasDownloadFn && !cfg.url)) {
                _context.next = 11;
                break;
              }
              err = new Error('Template download address not configured');
              _this.$emit('template-download-error', err);
              return _context.abrupt("return");
            case 11:
              _this.templateLoading = true;
              _context.prev = 12;
              if (!hasDownloadFn) {
                _context.next = 18;
                break;
              }
              _context.next = 16;
              return cfg.download({
                open: _this._openUrl
              });
            case 16:
              _context.next = 19;
              break;
            case 18:
              // 默认：window.open
              _this._openUrl(cfg.url);
            case 19:
              _this.$emit('template-download-success', cfg);
              _context.next = 26;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](12);
              _this.$message.warning(_context.t0 && _context.t0.message || 'Failed to download the template');
              _this.$emit('template-download-error', _context.t0);
            case 26:
              _context.prev = 26;
              _this.templateLoading = false;
              return _context.finish(26);
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[12, 22, 26, 29]]);
      }))();
    },
    /**
     * 以安全参数在新窗口打开 URL
     * @param {string} url - 目标地址
     * @private
     */
    _openUrl: function _openUrl(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    /**
     * 打开失败明细文件下载地址
     * @returns {void}
     */
    openFailFile: function openFailFile() {
      var url = this.resultData && this.resultData.failFileUrl;
      if (url) this._openUrl(url);
    },
    /**
     * 解析 `xxxProps`（Object / Function 两种形态）
     *
     * - Object：原样返回
     * - Function：调用并 `await`，支持同步 / 异步返回配置
     * - 最终保证 `params` 为对象
     *
     * @param {Object|Function} raw - 原始 props 值
     * @param {Object} context - 传给 Function 的上下文
     * @returns {Promise<ApiConfig>}
     * @private
     */
    resolveProps: function resolveProps(raw, context) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var resolved;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof raw === 'function')) {
                _context2.next = 6;
                break;
              }
              _context2.next = 3;
              return raw(context);
            case 3:
              resolved = _context2.sent;
              _context2.next = 7;
              break;
            case 6:
              resolved = raw;
            case 7:
              resolved = resolved || {};
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, resolved), {}, {
                params: _objectSpread({}, resolved.params || {})
              }));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * 响应解析：由 `cfg.adapter` 完全接管
     *
     * - adapter 存在：`await adapter(raw, { type, ...ctx })`，并将原始 `raw` 合并回结果
     * - adapter 不存在：假设响应体已是标准字段，原样返回并带上 `raw`
     *
     * @param {Object} raw - 原始响应体
     * @param {'credential'|'status'|'result'} type - 响应类型
     * @param {ApiConfig} cfg - 已解析的配置（可能含 adapter）
     * @param {Object} [ctx={}] - 额外上下文（file / credential / importResponse）
     * @returns {Promise<Object>} 标准结构（含 `raw`）
     * @private
     */
    resolveResponse: function resolveResponse(raw, type, cfg) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ctx, adapter, adapted;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ctx = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : {};
              adapter = cfg && cfg.adapter;
              if (!(typeof adapter === 'function')) {
                _context3.next = 7;
                break;
              }
              _context3.next = 5;
              return adapter(raw, _objectSpread({
                type: type
              }, ctx));
            case 5:
              adapted = _context3.sent;
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, adapted || {}), {}, {
                raw: raw
              }));
            case 7:
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, raw && _typeof(raw) === 'object' ? raw : {}), {}, {
                raw: raw
              }));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /* ===================================================
     *                  导入主流程
     * =================================================== */
    /**
     * el-upload 的 `http-request` 入口。
     *
     * 保持为同步方法，避免默认流程返回的 Promise 被 el-upload 再次消费，
     * 同时确保 customRequest 的 Promise / 请求句柄按原样返回。
     *
     * @param {Object} options - el-upload 传入的请求选项
     * @returns {void|Promise|Object} customRequest 的原始返回值，默认流程不返回请求
     */
    handleRequest: function handleRequest(options) {
      var file = options.file;
      this.$emit('request-start', file);
      if (typeof this.customRequest === 'function') {
        return this.runCustomRequest(options);
      }
      this.runDefaultRequest(options);
    },
    /**
     * 执行自定义上传请求。
     *
     * 原地包装 options.onSuccess / options.onError，使 customRequest 主动调用回调
     * 或返回 Promise 时，都能同步派发组件级 success / error 事件。
     *
     * @param {Object} options - el-upload 传入的请求选项
     * @returns {void|Promise|Object} customRequest 的原始返回值
     * @private
     */
    runCustomRequest: function runCustomRequest(options) {
      var _this2 = this;
      var file = options.file;
      var originalOnSuccess = options.onSuccess;
      var originalOnError = options.onError;
      var settled = false;
      options.onSuccess = function (result) {
        if (settled) return;
        settled = true;
        _this2.uploading = false;
        _this2.resultData = result || {};
        _this2.resultVisible = true;
        _this2.$emit('success', result, file);
        originalOnSuccess(result);
      };
      options.onError = function (err) {
        if (settled) return;
        settled = true;
        _this2.uploading = false;
        _this2.$emit('error', err, file);
        originalOnError(err);
      };
      this.uploading = true;
      try {
        return this.customRequest(options);
      } catch (err) {
        options.onError(err);
        return undefined;
      }
    },
    /**
     * 执行组件默认的完整导入流程：
     *
     * 1. 获取 OSS 凭证（Function 直接执行，Object 走默认请求 + adapter）
     * 2. PUT 文件到 OSS（进度通过 `options.onProgress` 同步到 el-upload）
     * 3. 触发业务导入（Function 直接执行，Object 走默认请求 + adapter）
     * 4. 获取结果：
     *    - sync：Function 返回值直接作为结果，Object 经 `importProps.adapter` 解析
     *    - async：轮询 `statusProps` 直到 `found=true`
     * 5. 展示结果并派发事件
     *
     * @param {Object} options - el-upload 传入的请求选项
     * @param {File} options.file - 当前文件
     * @param {Function} options.onSuccess - 成功回调
     * @param {Function} options.onError - 失败回调
     * @param {Function} [options.onProgress] - 进度回调，用于更新 el-upload 文件列表的进度条
     * @returns {Promise<void>}
     * @private
     */
    runDefaultRequest: function runDefaultRequest(options) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file, credential, uploadCfg, importCfg, importResponse, result, statusCfg;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = options.file;
              _this3.uploading = true;
              _context4.prev = 2;
              if (!(typeof _this3.uploadProps === 'function')) {
                _context4.next = 10;
                break;
              }
              _context4.next = 6;
              return _this3.uploadProps({
                file: file
              });
            case 6:
              credential = _context4.sent;
              _this3.validateCredential(credential);
              _context4.next = 16;
              break;
            case 10:
              _context4.next = 12;
              return _this3.resolveProps(_this3.uploadProps, {
                file: file
              });
            case 12:
              uploadCfg = _context4.sent;
              _context4.next = 15;
              return _this3.getUploadCredential(file, uploadCfg);
            case 15:
              credential = _context4.sent;
            case 16:
              _context4.next = 18;
              return _this3.putToOSS(file, credential, options);
            case 18:
              // ③ 触发业务导入
              _this3.$emit('import-start', file);
              importCfg = null;
              if (!(typeof _this3.importProps === 'function')) {
                _context4.next = 26;
                break;
              }
              _context4.next = 23;
              return _this3.importProps({
                file: file,
                credential: credential
              });
            case 23:
              importResponse = _context4.sent;
              _context4.next = 32;
              break;
            case 26:
              _context4.next = 28;
              return _this3.resolveProps(_this3.importProps, {
                file: file,
                credential: credential
              });
            case 28:
              importCfg = _context4.sent;
              _context4.next = 31;
              return _this3.triggerImport(credential, file, importCfg);
            case 31:
              importResponse = _context4.sent;
            case 32:
              if (!(_this3.mode === 'sync')) {
                _context4.next = 43;
                break;
              }
              if (!importCfg) {
                _context4.next = 39;
                break;
              }
              _context4.next = 36;
              return _this3.resolveResponse(importResponse, 'result', importCfg, {
                file: file,
                credential: credential
              });
            case 36:
              _context4.t0 = _context4.sent;
              _context4.next = 40;
              break;
            case 39:
              _context4.t0 = importResponse || {};
            case 40:
              result = _context4.t0;
              _context4.next = 51;
              break;
            case 43:
              if (_this3.statusProps) {
                _context4.next = 45;
                break;
              }
              throw new Error('Asynchronous Mode must be passed in: statusProps');
            case 45:
              _context4.next = 47;
              return _this3.resolveProps(_this3.statusProps, {
                file: file,
                credential: credential,
                importResponse: importResponse
              });
            case 47:
              statusCfg = _context4.sent;
              _context4.next = 50;
              return _this3.pollImportStatus(statusCfg, {
                file: file,
                credential: credential,
                importResponse: importResponse
              });
            case 50:
              result = _context4.sent;
            case 51:
              // ⑤ 展示与事件
              _this3.resultData = result || {};
              _this3.resultVisible = true;
              _this3.$emit('success', result, file);
              options.onSuccess(result);
              _context4.next = 61;
              break;
            case 57:
              _context4.prev = 57;
              _context4.t1 = _context4["catch"](2);
              _this3.$emit('error', _context4.t1, file);
              options.onError(_context4.t1);
            case 61:
              _context4.prev = 61;
              _this3.uploading = false;
              return _context4.finish(61);
            case 64:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 57, 61, 64]]);
      }))();
    },
    /**
     * 第 1 步：请求后端获取 OSS 上传凭证
     *
     * 请求参数 = `cfg.params` + 组件内置关键字段（`file_name`、`content_type`），
     * 内置字段**最后合并**，不允许被覆盖。
     *
     * 响应经 `uploadProps.adapter` 解析为标准 `Credential`，并校验必需字段。
     *
     * @param {File} file - 当前文件
     * @param {ApiConfig} cfg - 已解析的 `uploadProps`
     * @returns {Promise<Credential>}
     * @throws {Error} 未配置 url / 未解析到 putUrl / objectKey / contentType
     * @private
     */
    getUploadCredential: function getUploadCredential(file, cfg) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var url, _cfg$method, method, _cfg$params, params, payload, res, raw, std;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = cfg.url, _cfg$method = cfg.method, method = _cfg$method === void 0 ? 'post' : _cfg$method, _cfg$params = cfg.params, params = _cfg$params === void 0 ? {} : _cfg$params;
              if (url) {
                _context5.next = 3;
                break;
              }
              throw new Error('Not Configured uploadProps.url');
            case 3:
              payload = _objectSpread(_objectSpread({}, params), {}, {
                file_name: file.name,
                content_type: file.type
              });
              _context5.next = 6;
              return _this4.$http(_objectSpread({
                url: url,
                method: String(method).toUpperCase()
              }, String(method).toLowerCase() === 'get' ? {
                params: payload
              } : {
                data: payload
              }));
            case 6:
              res = _context5.sent;
              raw = res && res.data !== undefined ? res.data : res;
              _context5.next = 10;
              return _this4.resolveResponse(raw, 'credential', cfg, {
                file: file
              });
            case 10:
              std = _context5.sent;
              _this4.validateCredential(std);
              return _context5.abrupt("return", std);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    /**
     * 校验标准 OSS 凭证
     *
     * Object 和 Function 两种 uploadProps 形态共用同一套必填字段校验。
     *
     * @param {Credential} credential - 标准 OSS 凭证
     * @returns {void}
     * @throws {Error} 未解析到 putUrl / objectKey / contentType
     * @private
     */
    validateCredential: function validateCredential(credential) {
      var std = credential || {};
      if (!std.putUrl) {
        throw new Error('Failed to resolve the OSS upload address. Please check uploadProps result putUrl.');
      }
      if (!std.objectKey) {
        throw new Error('objectKey not parsed, please check uploadProps result');
      }
      if (!std.contentType) {
        throw new Error('contentType not parsed, please check uploadProps result');
      }
    },
    /**
     * 第 3 步：触发业务导入
     *
     * 请求参数 = `cfg.params` + 组件内置关键字段（`object_key`、`object_url`、`file_name`），
     * 内置字段**最后合并**，不允许被覆盖。
     *
     * @param {Credential} credential - 已解析的 OSS 凭证
     * @param {File} file - 当前文件
     * @param {ApiConfig} cfg - 已解析的 `importProps`
     * @returns {Promise<Object>} 导入接口的原始响应体
     * @throws {Error} 未配置 url
     * @private
     */
    triggerImport: function triggerImport(credential, file, cfg) {
      var url = cfg.url,
        _cfg$method2 = cfg.method,
        method = _cfg$method2 === void 0 ? 'post' : _cfg$method2,
        _cfg$params2 = cfg.params,
        params = _cfg$params2 === void 0 ? {} : _cfg$params2;
      if (!url) throw new Error('importProps.url is not configured');
      var payload = _objectSpread({}, params);
      return this.$http(_objectSpread({
        url: url,
        method: String(method).toUpperCase()
      }, String(method).toLowerCase() === 'get' ? {
        params: payload
      } : {
        data: payload
      })).then(function (res) {
        return res && res.data !== undefined ? res.data : res;
      });
    },
    /**
     * 第 2 步：PUT 文件到 OSS
     *
     * - 使用 `ossRequest`（而非 `this.$http`）：OSS 签名 URL 不能携带业务鉴权头，
     *   且 `this.$http` 的 JSON 克隆会破坏 `File` 与 `onUploadProgress`
     * - `Content-Type` 使用凭证返回的 `contentType`，否则 OSS 签名校验会失败
     * - 进度同时做两件事：
     *   ① `$emit('progress')` 派发给外部使用方
     *   ② 调用 `options.onProgress({ percent })` 更新 el-upload 文件列表的进度条
     *      （自定义 `http-request` 时，el-upload 不会自动追踪进度，必须手动通知）
     *
     * @param {File} file - 当前文件
     * @param {Credential} credential - 已解析的 OSS 凭证
     * @param {Object} [options] - el-upload 传入的请求选项，用于 `onProgress`
     * @returns {Promise<Object>} axios 响应
     * @fires ExcelUpload#progress
     * @private
     */
    putToOSS: function putToOSS(file, credential, options) {
      var _this5 = this;
      return ossRequest({
        method: credential.method || 'PUT',
        url: credential.putUrl,
        data: file,
        headers: {
          'Content-Type': credential.contentType
        },
        onUploadProgress: function onUploadProgress(e) {
          // ① 派发给外部使用方
          _this5.$emit('progress', e, file);

          // ② 通知 el-upload 更新进度条（文件列表里的百分比依赖这个）
          if (options && typeof options.onProgress === 'function') {
            var total = e.total || file.size;
            var percent = total ? Math.min(100, Math.round(e.loaded / total * 100)) : 0;
            options.onProgress({
              percent: percent
            });
          }
        }
      });
    },
    /**
     * 第 4 步（异步）：轮询状态接口直到 `found=true`
     *
     * 设计要点：
     * - `setTimeout` 放在 `Promise.finally`，保证上次请求结束后才安排下一次
     * - `done` 标志：`found=true` 或异常后不再安排下一次
     * - `pollingStopped`：组件销毁时停止轮询
     * - `maxCount`：超时保护
     *
     * @param {ApiConfig} cfg - 已解析的 `statusProps`
     * @param {Object} ctx - adapter 上下文 `{ file, credential, importResponse }`
     * @returns {Promise<StatusResult>} `found=true` 时的标准结构
     * @throws {Error} 未配置 url / 轮询超时 / 请求异常
     * @fires ExcelUpload#polling
     * @private
     */
    pollImportStatus: function pollImportStatus(cfg, ctx) {
      var _this6 = this;
      var url = cfg.url;
      var method = cfg.method || 'get';
      var params = cfg.params || {};
      var interval = cfg.interval || 2000;
      var maxCount = cfg.maxCount || 60;
      if (!url) return Promise.reject(new Error('statusProps.url is not configured'));
      this.pollingStopped = false;
      this.pollingTip = '';
      return new Promise(function (resolve, reject) {
        var count = 0;
        var done = false;
        var stopped = function stopped() {
          return _this6.pollingStopped;
        };
        var tick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var res, raw, std;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  if (!stopped()) {
                    _context6.next = 2;
                    break;
                  }
                  return _context6.abrupt("return");
                case 2:
                  count++;
                  if (!(count > maxCount)) {
                    _context6.next = 8;
                    break;
                  }
                  done = true;
                  _this6.pollingTip = '';
                  reject(new Error('Polling timed out. Please refresh later to view the results.'));
                  return _context6.abrupt("return");
                case 8:
                  _this6.pollingTip = "\u6B63\u5728\u67E5\u8BE2\u5BFC\u5165\u7ED3\u679C\uFF08\u7B2C ".concat(count, " \u6B21\uFF09...");
                  _context6.prev = 9;
                  _context6.next = 12;
                  return _this6.$http(_objectSpread({
                    url: url,
                    method: String(method).toUpperCase()
                  }, String(method).toLowerCase() === 'get' ? {
                    params: params
                  } : {
                    data: params
                  }));
                case 12:
                  res = _context6.sent;
                  raw = res && res.data !== undefined ? res.data : res;
                  _context6.next = 16;
                  return _this6.resolveResponse(raw, 'status', cfg, ctx);
                case 16:
                  std = _context6.sent;
                  if (std.found === true) {
                    done = true;
                    _this6.pollingTip = '';
                    resolve(std);
                  }
                  _this6.$emit('polling', count);
                  _context6.next = 26;
                  break;
                case 21:
                  _context6.prev = 21;
                  _context6.t0 = _context6["catch"](9);
                  done = true;
                  _this6.pollingTip = '';
                  reject(_context6.t0);
                case 26:
                  _context6.prev = 26;
                  if (!done && !stopped()) {
                    _this6._pollTimer = setTimeout(tick, interval);
                  }
                  return _context6.finish(26);
                case 29:
                case "end":
                  return _context6.stop();
              }
            }, _callee6, null, [[9, 21, 26, 29]]);
          }));
          return function tick() {
            return _ref.apply(this, arguments);
          };
        }();
        tick();
      });
    },
    /* ===================================================
     *                  el-upload 事件
     * =================================================== */
    /**
     * 文件状态变化回调：同步内部列表并派发事件
     * @param {Object} file - 当前文件
     * @param {Array<Object>} fileList - 最新文件列表
     * @fires ExcelUpload#input
     * @fires ExcelUpload#change
     * @private
     */
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      this.$emit('input', fileList);
      this.$emit('change', file, fileList);
    },
    /**
     * 文件移除回调：同步内部列表并派发事件
     * @param {Object} file - 被移除的文件
     * @param {Array<Object>} fileList - 最新文件列表
     * @fires ExcelUpload#input
     * @fires ExcelUpload#remove
     * @private
     */
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('input', fileList);
      this.$emit('remove', file, fileList);
    },
    /**
     * 文件数量超限回调
     * @private
     */
    handleExceed: function handleExceed() {
      // 最多上传{fileLimit}个文件
      this.$message.warning(this.$t('payroll_management_58', {
        fileLimit: 1
      }));
    },
    /**
     * 上传前校验包装：先走内置校验，再调用使用方 `beforeUpload`
     *
     * 校验失败会派发 `error` 事件，避免外层（如弹窗）的 submitting 状态卡死。
     *
     * @param {File} file - 当前文件
     * @returns {Promise<boolean>}
     * @fires ExcelUpload#error
     * @private
     */
    beforeUploadWrapper: function beforeUploadWrapper(file) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var check, err, r, _err;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              check = _this7.validateFile(file);
              if (check.valid) {
                _context7.next = 6;
                break;
              }
              _this7.$message.warning(check.msg);
              err = new Error(check.msg);
              _this7.$emit('error', err, file);
              return _context7.abrupt("return", Promise.reject(err));
            case 6:
              if (!(typeof _this7.beforeUpload === 'function')) {
                _context7.next = 21;
                break;
              }
              _context7.prev = 7;
              _context7.next = 10;
              return _this7.beforeUpload(file);
            case 10:
              r = _context7.sent;
              if (!(r === false)) {
                _context7.next = 15;
                break;
              }
              _err = new Error('Upload cancelled');
              _this7.$emit('error', _err, file);
              return _context7.abrupt("return", Promise.reject(_err));
            case 15:
              _context7.next = 21;
              break;
            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](7);
              _this7.$emit('error', _context7.t0, file);
              return _context7.abrupt("return", Promise.reject(_context7.t0));
            case 21:
              return _context7.abrupt("return", true);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[7, 17]]);
      }))();
    },
    /**
     * 文件校验：扩展名（不区分大小写）+ MIME + 大小
     * @param {File} file - 待校验文件
     * @returns {{ valid: boolean, msg?: string }}
     * @private
     */
    validateFile: function validateFile(file) {
      var name = file.name || '';
      var ext = name.split('.').pop().toLowerCase();
      var extList = (this.acceptExt || []).map(function (e) {
        return String(e).toLowerCase();
      });
      if (extList.length && !extList.includes(ext)) {
        return {
          valid: false,
          msg: this.$t('20252_ee20f753', {
            x: extList.join('、')
          })
        }; // 上传文件格式不正确，支持上传{x}格式
      }

      var mimeList = this.acceptMime || [];
      if (file.type && mimeList.length && !mimeList.includes(file.type)) {
        return {
          valid: false,
          msg: 'File MIME type mismatch'
        };
      }
      if (file.size / 1024 / 1024 > this.maxSize) {
        return {
          valid: false,
          msg: this.$t('730', {
            fileSize: this.maxSize
          })
        }; // 上传附件大小不能超过 {fileSize}MB
      }

      return {
        valid: true
      };
    },
    /* ===================================================
     *                  对外方法
     * =================================================== */
    /**
     * 手动触发上传（配合 `autoStart=false` 使用）
     * @returns {void}
     */
    submit: function submit() {
      if (this.$refs.elUpload && this.$refs.elUpload.submit) {
        this.$refs.elUpload.submit();
      }
    },
    /**
     * 清空文件列表与导入结果
     * @returns {void}
     * @fires ExcelUpload#input
     */
    clearFiles: function clearFiles() {
      this.fileList = [];
      this.resultVisible = false;
      this.resultData = {};
      this.pollingTip = '';
      this.$emit('input', []);
      if (this.$refs.elUpload && this.$refs.elUpload.clearFiles) {
        this.$refs.elUpload.clearFiles();
      }
    },
    /**
     * 获取当前文件列表
     * @returns {Array<Object>}
     */
    getFileList: function getFileList() {
      return this.fileList;
    }
  }
};